import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { updateDueDate } from "../../../api/caseApi";
import { DateTimeInput } from "../../../common/components/Input";
import { updateDueDateSchema } from "../schema/updateDueDateSchema";
import { getServiceProviderById } from "../../../api/serviceProviderApi";
import { normalizeDateTime } from "../../../common/helpers/normalizeDateTime";
import { StyledH4 } from "../../../common/components/Title/styles";
import { Stack } from "@mui/material";
const UpdateDueDateDialog = ({
  openUpdateDueDate,
  handleCloseUpdateDueDate,
  caseProgressId,
  getCaseStatusData,
  getSetsInfo,
  caseDetails,
  f2fConsultationInfo,
}) => {
  const {
    handleSubmit,
    formState: { isSubmitting },
    reset,
    control,
  } = useForm({
    resolver: yupResolver(updateDueDateSchema),
  });

  const [location, setLocation] = useState("");
  const fetchServiceProvider = async () => {
    const response = await getServiceProviderById(
      f2fConsultationInfo?.serviceProviderId
    );
    setLocation(response?.name);
  };

  const disableDates = (date) => {
    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 2);
    return yesterday > date;
  };
  useEffect(() => {
    let defaultValues = {};
    defaultValues.caseProgressId = caseProgressId;
    reset({ ...defaultValues });
    fetchServiceProvider();
  }, [caseProgressId, reset]);

  const submitUpdateDueDate = async (values) => {
    console.log(values);
    await updateDueDate(values);
    if (getSetsInfo != null) {
      await getSetsInfo();
    } else if (getCaseStatusData != null) {
      await getCaseStatusData();
    }
    handleCloseUpdateDueDate();
  };

  return (
    <div>
      <StyledDialog
        open={openUpdateDueDate}
        onClose={handleCloseUpdateDueDate}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Update Appointment Schedule</DialogTitle>
        <form onSubmit={handleSubmit(submitUpdateDueDate)}>
          <DialogContent dividers>
            {caseDetails != null && caseDetails.preferredDate1 != null ? (
              <Grid
                container
                direction="column"
                style={{
                  marginBottom: "20px",
                }}
              >
                <Grid item xs={12}>
                  <Stack
                    direction="column"
                    justifyContent="start"
                    sx={{ paddingBottom: 1 }}
                  >
                    <StyledH4 theme="lightpurple">
                      Patient's preferred schedule
                    </StyledH4>
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      fontFamily: "Inter",
                      fontSize: "15px",
                    }}
                  >
                    Location
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      fontFamily: "Inter",
                      fontSize: "15px",
                      fontWeight: "600",
                    }}
                  >
                    {location}
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      fontFamily: "Inter",
                      fontSize: "15px",
                    }}
                  >
                    Preferred Date 1
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      fontFamily: "Inter",
                      fontSize: "15px",
                      fontWeight: "600",
                    }}
                  >
                    {normalizeDateTime(caseDetails.preferredDate1) +
                      " " +
                      caseDetails.preferredTimeSlot1}
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      fontFamily: "Inter",
                      fontSize: "15px",
                    }}
                  >
                    Preferred Date 2
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      fontFamily: "Inter",
                      fontSize: "15px",
                      fontWeight: "600",
                    }}
                  >
                    {normalizeDateTime(caseDetails.preferredDate2) +
                      " " +
                      caseDetails.preferredTimeSlot2}
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      fontFamily: "Inter",
                      fontSize: "15px",
                    }}
                  >
                    Preferred Date 3
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      fontFamily: "Inter",
                      fontSize: "15px",
                      fontWeight: "600",
                    }}
                  >
                    {normalizeDateTime(caseDetails.preferredDate3) +
                      " " +
                      caseDetails.preferredTimeSlot3}
                  </div>
                </Grid>
              </Grid>
            ) : null}

            <Grid container direction="row">
              <Grid item xs={12}>
                <DateTimeInput
                  shouldDisableDate={disableDates}
                  label="Appointment Schedule"
                  name="datetime"
                  control={control}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              onClick={handleCloseUpdateDueDate}
              disabled={isSubmitting}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdateDueDateDialog;
